export default {
	show_: state => {
		const { show } = state.commCdDescModal;
		return show;
	},
	showCommCdLangModal_: state => {
		const { show } = state.commCdLangModal;
		return show;
	}
};
